export default __webpack_public_path__ + "static/media/nexus-optics-fpo.3c9d4a6a.png";